export const inputStyle = {
  width: '100%',
  mb: 2,
};
